import { Meta } from "../../types/meta";

const meta: Meta = {
  buildNumber: "Build #{{ build }}",
  platformName: "XDI Hub",
};

export default meta;
